module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/onesence-1-ac43e34a230bc6030a67cb99ea230ab0.webp";